<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardBody>
            <div class="row mb-3 mr-0 d-flex justify-content-end">
              <div class="col-auto pr-0">
                <CButton v-if="permissions.expenses.add" color="success" @click="createExpense()">
                  <CIcon :content="$options.addIcon" /> {{ $t('button.create') }} {{ $t('expenses.label') }}
                </CButton>
              </div>
            </div>
            <CDataTable
              :items="filteredItems"
              :fields="fields"
              :items-per-page="perPage"
              :itemsPerPageSelect="itemsPerPage"
              :tableFilter="tableFilter"
              :table-filter-value.sync="search"
              :loading="loading"
              addTableClasses="d-print-table table-dropdown-fix"
              hover
              sorter
              pagination
            >
              <template #expense_type="{item}">
                <td>
                  {{item.expense_type.name}}
                </td>
              </template>
              <template #employee="{item}">
                <td>
                  {{item.employee.name}}
                </td>
              </template>
              <template #quantity="{item}">
                <td>${{ item.quantity }}</td>
              </template>
              <template #options="{item}">
                <td>
                  <div class="dropdown">
                    <button class="btn btn-secondary dropdown-toggle" @click="openOptions" type="button" data-toggle="dropdown">
                      {{ $t('button.options') }}
                    </button>
                    <div class="dropdown-menu">
                      <button v-if="permissions.expenses.read" class="dropdown-item" type="button" @click="showExpense(item.id)">{{ $t('button.details') }}</button>
                      <button v-if="permissions.expenses.edit" class="dropdown-item" type="button" @click="editExpense(item.id)">{{ $t('button.edit') }}</button>
                      <button v-if="permissions.expenses.delete" class="dropdown-item" type="button" @click="deleteExpense(item.id)">{{ $t('button.delete') }}</button>
                    </div>
                  </div>
                </td>
              </template>
              <template #under-table>
                <CPagination 
                :pages="totalPages"
                :activePage.sync="currentPage"
                @update:activePage="changePage()"
                >
                </CPagination>
              </template>
            </CDataTable>
        </CCardBody>  
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import listMixin from '../../mixins/list';
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";
import { cilPlus } from '@coreui/icons';

export default {
  name: 'Expenses',
  mixins: [listMixin, localeMixin],
  addIcon: cilPlus,
  data() {
    return {
      items: [],
      fields: [
        { key: 'expense_type', label: i18n.t('fields.expense_type') }, 
        { key: 'employee', label: i18n.t('fields.employee') }, 
        { key: 'quantity', label: i18n.t('fields.quantity') },
        { key: 'expense_date', label: i18n.t('fields.expense_date') },
        {
          key: 'options',
          label: i18n.t('button.options'),
          sorter: false,
          filter: false
        }
      ],
      you: null,
      tableFilter: {
        label: i18n.t('search'),
        placeholder: i18n.t('expenses.search_placeholder'),
        lazy: false,
        external: true
      },
    }
  },
  computed: {
    ...mapState({
      permissions: state => state.permissions,
    }),
    filteredItems() {
      return this.items.filter(i => {
        return i.employee.name.toLowerCase().includes(this.search.toLowerCase());
      });
    }
  },
  mounted() {
    this.getExpenses();
  },
  methods: {
    showExpense(id) {
      this.$router.push({ name: 'Expense', params: {id} });
    },
    editExpense(id) {
      this.$router.push({ name: 'EditExpense', params: {id} });
    },
    deleteExpense(id) {
      axios.post('/api/expenses/' + id + '?token=' + localStorage.getItem("api_token"), {
        _method: 'DELETE'
      })
      .then(response => {
          this.message = 'Successfully deleted expense.';
          this.showAlert();
          this.getExpenses();
      }).catch(function (error) {
        console.log(error);
        this.$router.push({ path: '/login' });
      });
    },
    createExpense () {
      this.$router.push({ name: 'CreateExpense'});
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    getExpenses(current_page=1, per_page=10) {
      this.loading = true;
      const token = this.token === null ? localStorage.getItem('api_token') : this.token;
      const url = '/api/expenses?page='+ current_page +'&per_page='+ per_page+'&token='+token;

      axios.get(url)
      .then(response => {
        this.items = response.data.data;
        this.totalPages = response.data.last_page
        this.items.forEach(elem => {
          elem.status_class = elem.active ? "primary" : "secondary";
        });
        this.loading = false;
      }).catch(error => {
        console.log(error);
        this.$router.push({ path: '/login' });
      });
    },
    changePage() {
      this.getExpenses(this.currentPage, this.perPage);
    },
  }
}
</script>

